import { TimezoneService } from '@ui/lib';

export const LocalTimezone = () => {
  const formattedTimezone = TimezoneService.getUserLocalTimezoneWithOffset();
  return <p className="font-light text-xs">{formattedTimezone}</p>;
};
